  
 
  <form  [formGroup]="formDialog">
    <h2 mat-dialog-title>
        Add Custom Description to {{data.customInfoName}}
        <button mat-icon-button (click)="closeAddTouchType()">
        <mat-icon>close</mat-icon>
        </button>
    </h2>
    
  <mat-dialog-content class="mat-typography">
    <mat-form-field class="example-full-width">
        <mat-label>Custom Description</mat-label>
        <input matInput maxlength="50" placeholder="Select/Add Custom Description" formControlName="statusName"
        (input)="onSearchChange($event.target.value)"/>       
      </mat-form-field> 
  
  </mat-dialog-content>
  
  <div class="tabContainer">
    <div class="d-flex">       
    
        <div class="template-holder">
         
         <div class="right">                   
                       
           <div class="list">
    
            <div class="tempalteList">
              <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundStatus">
                <tr>
                  <th>Custom Description</th>             
                  <th class="actBtn">Action</th>
                </tr>
                <tr *ngFor="let data of statusList"
                  [ngClass]="{ 'active': data.touchStatusID === selectedcustomNoteStatusID}">
    
                  <td class="formName" style="cursor: pointer;" (click)="SelectStatus(data)">
                    {{data.customNoteStatusName}}
                  </td>            
    
                  <td>
                    <button mat-button color="primary" (click)="SelectStatus(data)">Select</button>                           
                  </td>
                </tr>

              </table>
              <div *ngIf="ShowNoRecordFoundStatus" class="noRecordFound">No Record Found</div>
            </div>
    
           </div>
      
         </div>
      </div>  

    </div>
 
  </div>   

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="closeAddTouchType()">Cancel</button>
    <button mat-flat-button color="primary"    
    [disabled]="showDisabled==true"
    (click)="AddStatusName(formDialog.value)">Save
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
  </mat-dialog-actions>
  
    </form>
  

  




